<div class="row mx-auto justify-content-center mt-5">

    <div class="col-8 mb-3">

        <mat-card>
            <h4 class="card-header">Filtrer les fiches avec les options suivantes:</h4>

            <div class="row">
                <div class="col-6">
                    <div class="example-container">

                        <mat-form-field>
                            <mat-label>Code postal</mat-label>
                            <mat-select [(ngModel)]="codepostal" multiple>

                                <mat-option value="{{i}}" *ngFor="let i of codeP">{{i}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                </div>
                <div class="col-6">
                    <div class="example-container">

                        <mat-form-field>
                            <mat-label>Email</mat-label>
                            <mat-select [(ngModel)]="email">
                                <mat-option value=""></mat-option>

                                <mat-option value="avec">Avec</mat-option>
                                <mat-option value="sans">Sans</mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="example-container">

                        <mat-form-field>
                            <mat-label>Numéro</mat-label>
                            <mat-select [(ngModel)]="tel">
                                <mat-option value=""></mat-option>

                                <mat-option value="fix">Fixe</mat-option>
                                <mat-option value="mobil">Mobile</mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                </div>
                <div class="col-6">
                    <div class="example-container">

                        <mat-form-field>
                            <mat-label>Statut habitation</mat-label>
                            <mat-select [(ngModel)]="statut">
                                <mat-option value=""></mat-option>

                                <mat-option value="maison">Maison</mat-option>
                                <mat-option value="appartement">Appartement</mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                </div>
            </div>
            <div class="card-body text-center">
                <button class="mb-2 mr-2 btn btn-primary pull-right" (click)="filtre()">Confirmer le filtrage</button>
                <button class="mb-2 mr-2 btn btn-secondary pull-right"
                    *ngIf="okDownload ==true && tokenStorageService.getRole() == 'ROLE_ADMIN'"
                    (click)="exporter1()" [disabled]="disabledExport1">Télécharger</button>

<p>{{testExport}}</p>
            </div>

        </mat-card>
    </div>
</div>

<div class="row">
    <div class="col-10"></div>
    <div class="col-2">
        <button mat-raised-button color="warn" (click)="supprimer1()">Supprimer BDD</button>

    </div>
</div>

<div class="row mt-5 mb-2">
    <div class="col-3"></div>
    <div class="col-6">

        <div class="example-header">
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field>
        </div>

    </div>

</div>


<div class="row mt-5" id="cons">

    <div class="col-md-12">



        <div class="mb-5 col-xs" style="width: 97%;margin-left: 2%;">
            <div class="example-container mat-elevation-z8">
                <mat-table #table [dataSource]="listResult" matSort >
                    <!-- Position Column -->
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p> ID</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.id}}
                            <p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="civilite">
                        <mat-header-cell *matHeaderCellDef>
                            <p>Civilité</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.civilite}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nom">
                        <mat-header-cell *matHeaderCellDef>
                            <p> Nom</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>{{element.nom}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="adresse">
                        <mat-header-cell *matHeaderCellDef>
                            <p>Adresse</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>{{element.adresse}}</p>
                        </mat-cell>
                    </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="codepostal">
                        <mat-header-cell *matHeaderCellDef>
                            <p>Code postal</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.codepostal}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ville">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p> ville</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>{{element.ville}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="tel1">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Tel1</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.telmob}}</p>
                        </mat-cell>
                    </ng-container>
                    <!-- Weight Column -->
                    <ng-container matColumnDef="tel2">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Tel2</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <p> {{element.telfix}}</p>


                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="mail">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Email</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <p> {{element.mail}}</p>


                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="commentaire">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Commentaire</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <p> {{element.commentaire}}</p>


                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div class="example-button-row">
                                <div class="example-flex-container">
                                    <div class="example-button-container">
                                        <button mat-mini-fab color="primary" class="btn1"
                                            (click)="supprimer(element.id)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div class="example-button-row">
                                <div class="example-flex-container">
                                    <div class="example-button-container">
                                        <button mat-mini-fab color="basic" class="btn1" type="button"
                                        (click)="openModal(element)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </mat-cell>
                    </ng-container>


                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>

                
            </div>
       
        </div>

       
        
      <div class="row mb-3" *ngIf="paginatetest == false">
          <div class="col-12 text-center">
            <a  class="previous" (click)="pre()">&laquo; Précédent  </a>
            <a  class="next" (click)="suiv()">Suivant &raquo; </a>
          </div>
      </div>
      <div class="row mb-3" *ngIf="paginatetest == true">
        <div class="col-12 text-center">
          <a  class="previous" (click)="pre1()">&laquo; Précédent  </a>
          <a  class="next" (click)="suiv1()">Suivant &raquo; </a>
        </div>
    </div>
                   
    </div>

</div>






<div class="row">
    <div class="col-1"></div>

    <div class="col-md-10">

        <div class="main-card mb-3 card" style="height: 94%;">
            <div class="card-body">

                <form [formGroup]="uploadForm1" (ngSubmit)="uploadSubmit1()">
                    <mat-card-content>


                        <input formControlName="document" class="foo" type="file" (change)="onFileChange($event)"
                            ng2FileSelect [uploader]="uploader1" /><br />

                        <hr>
                        <div class="drop-zone">
                            <div ng2FileDrop [uploader]="uploader1" style="min-height: 150px;
                        border: 2px dashed #00B5B8;
                        background: #F5F7FA;" class="drop-zone">
                                <h2 class="text-center mt-5">Glissez le document BDD</h2>
                            </div>
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th width="90%">

                                    </th>
                                    <th width="10%">

                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of uploader1.queue;let x=index">
                                    <th width="90%">
                                        document {{x+1}}
                                    </th>
                                    <th class="text-center" width="20%">
                                        <button type="button" class="btn btn-light" (click)="effacer()"
                                            (click)="item.remove()">
                                            Annuler
                                        </button>

                                    </th>
                                </tr>

                            </tbody>
                        </table>
                        <table class="table" width="100%" *ngIf="dataExel != null">
                            <thead>
                                <tr>
                                    <th>Civilité</th>
                                    <th>Nom</th>

                                    <th>Adresse</th>
                                    <th>code postal</th>
                                    <th>email</th>
                                    <th>Tél Mob</th>
                                    <th>TélFixe</th>
                                    <th>Commentaire</th>

                                </tr>
                            </thead>
                            <tbody *ngFor="let row of dataExel;let i =index">
                                <tr *ngIf="i &#60; 4">
                                    <td>{{row.Civilite}}</td>
                                    <td>{{row.Nom}}</td>
                                    <td>{{row.Adresse}}</td>
                                    <td>{{row.Codepostal}}</td>
                                    <td>{{row.Email}}</td>
                                    <td>{{row.Telephonemobil}}</td>
                                    <td>{{row.Telephonefixe}}</td>
                                    <td>{{row.Commentaire}}</td>


                                </tr>
                            </tbody>
                        </table>
                        <br>
                    </mat-card-content>
                </form>

            </div>

            <div class=" d-block text-left card-footer">
                <button class="mb-2 mr-2 btn btn-primary" (click)="uploadSubmit1()">Enregistrer</button>
                <button [disabled]="disable" *ngIf="pasHide =='oui'" class="mb-2 mr-2 btn btn-success" (click)="addPas()">Appuyer +</button>
                <p>{{message}}</p>
            </div>
         
            <div class="alert alert-danger" *ngIf="isOk1 == false">
                Upload échouée!
            </div>

            <div class="alert alert-success" *ngIf="isOk1 == true">
                Votre upload est réussie! Appuyer + pour charger le fichier
            </div>
        </div>



    </div>
</div>





<div class="row" *ngIf="tokenStorageService.getRole() == 'ROLE_ADMIN'">
    <div class="col-3"></div>

    <div class="col-md-6">

        <div class="main-card card" style="height: 94%;">
            <div class="card-body text-center">
                <h4>Exporter fiches BDD</h4>
                <button class="mr-2 btn btn-primary" [disabled]="disabledExport" (click)="exporter()">Exporter</button>

                <p>{{testExport}}</p>
            </div>

        </div>



    </div>
</div>

<div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':display}">
     <div class="modal-dialog" role="document">
           <div class="modal-content">
                 <div class="modal-header">
                       <h4 class="modal-title">Modifier fiche</h4>
                     </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <input matInput placeholder="Nom" [(ngModel)]="fiche.nom">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field >
                            <mat-label>Civilité</mat-label>
                            <mat-select  [(ngModel)]="fiche.civilite">

                                <mat-option  value="Mr">Mr</mat-option>
                                <mat-option value="Mme">Mme</mat-option>
                            </mat-select>
                        </mat-form-field>
                        
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <input matInput placeholder="Téléphone mobile" [(ngModel)]="fiche.telmob">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <input matInput placeholder="Téléphone fixe" [(ngModel)]="fiche.telfix">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <input matInput placeholder="Ville" [(ngModel)]="fiche.ville">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <input matInput placeholder="Code postal" [(ngModel)]="fiche.codepostal">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <input matInput placeholder="Email" [(ngModel)]="fiche.mail">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <input matInput placeholder="Adresse" [(ngModel)]="fiche.adresse">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
        
                    <div class="col-12">
                        <mat-form-field>
                            <input matInput placeholder="Commentaire" [(ngModel)]="fiche.commentaire">
                        </mat-form-field>
                    </div>
                </div>
      
                                 </div>
                 <div class="modal-footer">
                    <button mat-raised-button color="primary" (click)="modifier()">Enregistrer</button>
                    <button mat-raised-button (click)="onCloseHandled()" >Fermer</button>

                     </div>
        </div>
         </div>
</div>